import React from "react";
import Login from "../../Login/Login";

export default class XLinkLogin extends React.PureComponent {
  render() {
    return <Login redirect="/xlink" />;
  }
}
